import React, { useMemo, useContext, useEffect, useState } from "react"
import useFilterBy from "../hooks/useFilterBy"
import { ScrollContext } from "../context/scrollContext";
import { GatsbyImage } from "gatsby-plugin-image"
import Spacer from "../components/spacer"
import ProjectListing from "./projectListing"
import ProjectCard from "./projectCard"
import { sortBy, groupBy } from 'lodash'
import VideoPlayer from "./videoPlayer";
import FilterLinks from "./filterLinks";
import { SwitchTransition, CSSTransition } from "react-transition-group";

const AllProjects = ({ projects, categories, groupByYear = false, ...props }) => {

  const [filtered, filterBy, currentFilter] = useFilterBy(projects)

  const views = ['grid', 'list']
  const [currentView, setCurrentView] = useState(views[0])

  const filterableCategories = [{ name: 'All', id: 'all' }, ...categories];

  return (
    <div {...props} >
      <div className="project--list p10 pb0">
        <div className="left-column m-hide" />
        <div className="right-column flex justify-sb align-bottom">
          <FilterLinks currentFilter={currentFilter} filterableCategories={filterableCategories} filterBy={filterBy} />
          <ViewsLinks views={views} setCurrentView={setCurrentView} currentView={currentView} />
        </div>
      </div>
      <Projects currentFilter={currentFilter} groupByYear={groupByYear} view={currentView} filtered={filtered} />
    </div>
  )
}



const ViewsLinks = ({ currentView, setCurrentView, views }) => {
  return (
    <div className="flex gap-15 w-280 m-wa justify-right">
      {views.map((view, index) => {
        var name;
        if (view === 'list') { name = 'index'; } else { name = view }
        return (
          <button key={index} className={"radio-link button capitalize  " + (view.toLowerCase() === currentView ? 'active' : ' ')} onClick={() => setCurrentView(view)}>
            {name}
          </button>
        )
      })}
    </div>
  )
}


const Projects = ({ view, filtered, groupByYear, currentFilter }) => {
  const { scrollActions } = useContext(ScrollContext)

  const Views = useMemo(() => {
    return {
      grid: Grid,
      list: List
    }
  }, [])

  const CurrentView = useMemo(() => {
    return Views[view]
  }, [Views, view])

  useEffect(() => {
    scrollActions.update(view)
  }, [view, scrollActions.update])

  return (
    <CurrentView update={scrollActions.update} currentFilter={currentFilter} groupByYear={groupByYear} id={view} key={view} filtered={sortBy(filtered, ["year"]).reverse()} />
  )
}

const Grid = ({ filtered, currentFilter, update }) => {

  return (
    <SwitchTransition>
      <CSSTransition onEntered={update} timeout={500} classNames='fade-grid' key={currentFilter}>
        <div id='grid' className='project--grid p10 grid'>
          {filtered.map((project) => {
            return (
              <ProjectCard project={project} key={`grid-${project.name}`} />
            )
          })}
        </div>
      </CSSTransition>
    </SwitchTransition>
  )
}


function VideoOrImage({ media, style }) {

  if (media?.thumbnail?.gatsbyImageData) {
    return (
      <div className='bg-image' style={style}>
        <GatsbyImage className='bg-image' image={media?.thumbnail?.gatsbyImageData} alt="Project Preview" />
      </div>
    )
  } else if (media?.featuredVideo) {

    return (
      <div style={style} className="bg-image video-wrapper ">
        <VideoPlayer url={media?.featuredVideo} />
      </div>
    )
  } else {
    return null
  }
}


const List = ({ filtered, groupByYear, update, currentFilter }) => {

  const groupedProjects = useMemo(() => {
    if (!groupByYear) {
      return [['all', filtered]]
    }

    return Object.entries(groupBy(filtered, 'year')).reverse()
  }, [filtered, groupByYear])

  useEffect(() => {
    update(currentFilter)
  }, [update, currentFilter])
  
  return (
    groupedProjects.map(([key, projects], index) => {
      return (
        <ProjectList projects={projects} year={key} key={key} index={index} />
      )
    })

  )
}



const ProjectList = ({ year, projects, index }) => {
  console.log(projects)
  const [firstProject] = projects
  const [currentProject, setCurrentProject] = useState()

  useEffect(() => {
    setCurrentProject(firstProject.name)
  }, [firstProject.name])

  return (
    <>
      {index !== 0 ?
        <>
          <Spacer />
          <Spacer className='m-hide' />
          <h1 className='m0 text-light'>C.{year}</h1>
          <Spacer />
        </>
        :
        null
      }
      <div id={'list' + year} className="p10 project--list">
        <div className="left-column pb60 m-hide">
          <div id={'project-list' + year} className='h-100'>
            <div className="max-150" data-scroll data-scroll-sticky data-scroll-target={'#project-list' + year} data-scroll-offset="-60" >
              <div className=" ratio-1-2 project--preview pos-rel">
                {projects.map((project) => {
                  return <VideoOrImage key={project.name} style={{ opacity: (project.name === currentProject) ? 1 : 0 }} media={project} />
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="right-column ">
          <div className="bb1">
            {sortBy(projects, 'name').map((project, index) => {
              return (
                <ProjectListing currentProject={currentProject} onMouseEnter={() => setCurrentProject(project.name)} project={project} key={`list-${project.name}`} />
              )
            })}
          </div>
        </div>

      </div>
    </>
  )
}


export default AllProjects
